<template>
  <div class="streamfield">
    <template v-for="item in items">
      <template v-if="item != null && item.hasOwnProperty('type')">
        <div v-if="item.type == 'blockquote_block'" class="blockquote_block" :key="item.id">
          {{item.value}}
        </div>
        <div v-if="item.type == 'embed_block'" class="embed_block" :key="item.id">
          {{item.value}}
        </div>
        <div v-if="item.type == 'heading_block'" class="heading_block" :key="item.id">
          <h1 v-if="item.value.size == 'h1'" class="title"><span v-if="item.value.icons" :class="'icon-' + item.value.icons"></span>{{item.value.heading_text}}</h1>
          <h2 v-if="item.value.size == 'h2'" class="title"><span v-if="item.value.icons" :class="'icon-' + item.value.icons"></span>{{item.value.heading_text}}</h2>
          <h3 v-if="item.value.size == 'h3'" class="title"><span v-if="item.value.icons" :class="'icon-' + item.value.icons"></span>{{item.value.heading_text}}</h3>
          <h4 v-if="item.value.size == 'h4'" class="title"><span v-if="item.value.icons" :class="'icon-' + item.value.icons"></span>{{item.value.heading_text}}</h4>
          <h5 v-if="item.value.size == 'h5'" class="title"><span v-if="item.value.icons" :class="'icon-' + item.value.icons"></span>{{item.value.heading_text}}</h5>
          <h6 v-if="item.value.size == 'h6'" class="title"><span v-if="item.value.icons" :class="'icon-' + item.value.icons"></span>{{item.value.heading_text}}</h6>
        </div>
        <div v-if="item.type == 'image_block'" class="image_block" :key="item.id">
          <img :src="baseUrl + '/' + item.value.thumb.src" :alt="item.value.caption">
        </div>
        <div v-if="item.type == 'paragraph_block'" class="paragraph_block" ref="paragraph" v-html="correctImagePath(item.value)" :key="item.id"></div>
      </template>
    </template>
  </div>
</template>

<script>

export default {
  data(){
    return{
      baseUrl: process.env.VUE_APP_BASE_URL,
    }
  },

  computed: {},

  props: {
    items: {
      type: Array,
      default: function() {
        return []
      }
    },
  },

  watch: {
    $route (){
      this.$nextTick(function(){
        this.hrefToRouterLink()
      })
    },
  },

  methods:{
    correctImagePath: function(value){
      return value.replace(/src="\/media\//g, 'src="' + process.env.VUE_APP_BASE_URL + '/media/')
    },
    hrefToRouterLink: function(){
      const paras = this.$refs['paragraph']
      let ref = ''
      let kwd = ''
      if(paras && paras.length > 0){
        const currentPath = this.$route.path.split('/')
        if(currentPath.length > 0) {
          ref = currentPath[1]
          if(currentPath.length > 1) {
            kwd = currentPath[2]
          }
        }
        paras.forEach(para => {
          const links = para.getElementsByTagName('a')
          links.forEach(link => {
            const result = link.href.match(/^https?:\/{2,}(.*?)[:|/]/)[1]
            if(document.domain == result) {
              const self = this
              const href = link.pathname
              const locale_removed = href.replace(/^(\/\w{2}\/)/gi, '/')
              link.removeAttribute('href')
              link.addEventListener('click', function(){
                self.$router.push(locale_removed + (ref ? '?ref=' + ref : '') + (kwd ? '&kwd=' + kwd : ''))
              });
            }
          });
        });
      }
    }
  },

  created(){},

  mounted() {
    this.hrefToRouterLink()
  }
}
</script>
<style lang="sass"></style>
